import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

let locale = window.location.pathname.replace(/^\/([^/]+).*/i, '$1')

// console.log('window location is ', locale)
// if(locale === ""){
//   locale = navigator.language.slice(0,2)
// }

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/About.vue')
  },
  {
    path: '/spots',
    name: 'spots',
    component: () => import('../views/SpotsIndex.vue')
  },
  {
    path: '/keywords/:slug?',
    name: 'keywords',
    component: () => import('../views/KeywordsIndex.vue')
  },
  {
    path: '/locations/:slug?',
    name: 'locations',
    component: () => import('../views/LocationsIndex.vue')
  },
  {
    path: '/spots/:slug',
    name: 'spot',
    component: () => import('../views/SpotPage.vue')
  },
  {
    path: '/tours',
    name: 'tours',
    component: () => import('../views/ToursIndex.vue')
  },
  {
    path: '/tours/:slug',
    name: 'tour',
    component: () => import('../views/TourPage.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/' + locale + '/',
  routes,
  scrollBehavior (to, from, savedPosition) { // eslint-disable-line no-unused-vars
    return { x: 0, y: 0 }
  }
})

export default router
